"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SideNavigationBase = _ref => {
  let {
    component: Component,
    dark,
    icon,
    label,
    status,
    forwardRef,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Component, _extends({
    ref: forwardRef
  }, props), icon ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: icon,
    light: dark,
    className: "p-side-navigation__icon"
  }) : null, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-side-navigation__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "p-side-navigation__label"
  }, label)), status ? /*#__PURE__*/_react.default.createElement("div", {
    className: "p-side-navigation__status"
  }, status) : null);
};
var _default = exports.default = SideNavigationBase;